import angular from 'angular';
import productLabelDownloadComponent from './product-label-download.component';

export default angular.module('common.components.productLabelDownload', [])
  .component('productLabelDownload', productLabelDownloadComponent)
  .name;



// WEBPACK FOOTER //
// ./components/app/product/information/product-label-download/product-label-download.module.js